.card {
  min-width: 0;
  padding: var(--space-5);
  border-radius: var(--radius-card);
  background: var(--card);
  box-shadow: var(--shadow-card);
}

@media (max-width: 719px) {
  .card {
    padding: var(--space-4);
  }
}
